import { Button, Col, Row, Typography } from 'antd';
import React from 'react';
import buskSeller from '../services/buskSeller';

interface Props {
  rowData: any;
  count: number;
  selectedRow: React.Key[];
  page: number;
  fromDt: string;
  toDt: string;
  filterState: string;
  filter: string;
  filterInput: string;
  sort: boolean;
}

const SellerList = ({
  rowData,
  count,
  selectedRow,
  page,
  fromDt,
  toDt,
  filterState,
  filter,
  filterInput,
  sort
}: Props) => {
  const handleOnExport = async () => {
    if (selectedRow.length > 0) {
      const response = await buskSeller.exportSellerExcellById(selectedRow);
      const outputFilename = `Seller_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await buskSeller.exportSellerExcell(
        page,
        fromDt,
        toDt,
        filterState,
        filter,
        filterInput,
        sort
      );
      const outputFilename = `Seller_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };
  return (
    <div className="busk-sellerSubHead">
      <Row align="middle">
        <Col flex="auto">
          <Row gutter={15}>
            <Col>
              <Typography.Text>총 셀러 {count}</Typography.Text>
            </Col>
            <Col>|</Col>
            <Col>
              <Typography.Text>선택 셀러 {selectedRow.length}</Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button
            style={{
              color: 'gray'
            }}
            onClick={() => handleOnExport()}
          >
            엑셀 다운로드
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SellerList;
